import React from 'react';

import { logoUrl, siteName } from '@strongio/pretrained-dashboard/settings';
import ErrorBoundary from '@strongio/pretrained-dashboard/components/ErrorBoundary';

export default function CompactLayout({ title, children, subtitle }) {
  return /*#__PURE__*/(
    React.createElement("div", { className: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }, /*#__PURE__*/
    React.createElement("div", { className: "sm:mx-auto sm:w-full sm:max-w-md" }, /*#__PURE__*/
    React.createElement("img", {
      className: "mx-auto h-12 w-auto",
      src: logoUrl,
      alt: siteName }), /*#__PURE__*/

    React.createElement("h2", { className: "mt-6 text-center text-3xl font-bold text-gray-900" },
    title),

    subtitle), /*#__PURE__*/

    React.createElement("div", { className: "mt-8 sm:mx-auto sm:w-full sm:max-w-lg" }, /*#__PURE__*/
    React.createElement("div", { className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" }, /*#__PURE__*/
    React.createElement(ErrorBoundary, null, children)))));




}